import { Checkbox, IconButton, useTheme } from "@mui/material";
import {ReactComponent as UnfoldIcon} from '../../assets/images/mi-portal/unfold.svg';
import { TableRow } from ".";
import { CSSProperties } from "react";


export interface TableHeadRows {
    label: string;
    rowKeyName: string,
    buildOrderValue?: (value: string) => string,
    // orderAction?: (header: TableHeadRows, headerIndex: number) => void,
    allowOrderAction?: boolean,
    customValue?: (headRow: TableHeadRows, row: TableRow<string, any>) => {},
    isSearchable?: boolean,
    rowStyle?: (row: TableRow<string, any>) => CSSProperties,
}


interface TableHeadProps {
    tableHeadRows: TableHeadRows[],
    handleOrderAction: (th: TableHeadRows, i: number) => void;
    setSelectionItems?: () => void;
    allItemsSelected: boolean;
}

const TableHead = ({tableHeadRows, handleOrderAction, setSelectionItems, allItemsSelected}: TableHeadProps) => {

    const theme = useTheme();

    return (
        <thead
            style={{
                backgroundColor: "rgba(232, 232, 232, .5)",
                whiteSpace: "nowrap"
            }}
        >
        <tr style={{border: "none !important",}}>
            {setSelectionItems && 
                <th 
                    style={{
                        color: theme.s10palette.S10Greygrey600,
                        width: "2rem",
                    }}
                >
                    <Checkbox onClick={setSelectionItems} checked={allItemsSelected} />
                </th>
            }
            {tableHeadRows?.map((th, i) => (
                <th 
                    key={i}
                    style={{
                        minWidth: "2rem",
                        padding: "0.75rem 1rem",
                        color: theme.s10palette.S10Greygrey600,
                        fontFamily: "Roboto",
                        fontSize: "0.875rem",
                        fontStyle: "normal",
                        fontWeight: "600",
                        lineHeight: "normal",
                        textAlign: "left"
                    }}
                >
                    {th.label} 
                    {th.allowOrderAction && (<IconButton onClick={() => handleOrderAction(th, i)}>
                        <UnfoldIcon style={{fontSize: ".75rem", color: theme.s10palette.S10Greygrey600}}/>
                    </IconButton>)}
                </th>
            ))}
        </tr>
        </thead>
    )
}

export default TableHead;